import PropTypes from 'prop-types';

const questionsPropTypes = PropTypes.shape({
	id: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
	text: PropTypes.string.isRequired,
	dateCreated: PropTypes.string.isRequired,
	answerCount: PropTypes.number,
	answers: PropTypes.arrayOf(PropTypes.any),
	isStaff: PropTypes.bool,
	user: PropTypes.shape({
		nickName: PropTypes.string
	}),
	upVotes: PropTypes.number.isRequired
});

const answerPropTypes = PropTypes.shape({
	id: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
	text: PropTypes.string.isRequired,
	dateCreated: PropTypes.string.isRequired,
	user: PropTypes.shape({
		nickName: PropTypes.string,
		badge: PropTypes.shape({
			text: PropTypes.string,
			imageUrl: PropTypes.string
		})
	}),
	recommendedProducts: PropTypes.arrayOf(PropTypes.any)
});

export { questionsPropTypes, answerPropTypes };
